















































import { Component, Prop, Vue } from 'vue-property-decorator';
import TaskCard from '@/components/TaskCard.vue';
import NewCard from '@/components/NewCard.vue';
import { CardData } from '@/types/cardData';

@Component({
  name: 'PageContent',
  components: { TaskCard, NewCard },
})

export default class PageContent extends Vue {
  @Prop({ type: Array, required: true }) public cards!: CardData[];

  public isCreateCard: boolean = false;
  public searchText: string = '';

  public taskCards: CardData[] = this.cards;

  public createNewCard(): void {
    this.isCreateCard = true;
  }

  public setCardToArchive(index: number): void {
    const archivedCard = this.cards.splice(index, 1);
    this.$emit('setCardToArchive', archivedCard);
  }

  public deleteCard(index: number): void {
    this.cards.splice(index, 1);
  }

  public searchCard(): void {
    if (this.searchText.toLowerCase()) {
      this.taskCards = this.cards.filter((el) => el.title.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1);
    } else if (this.searchText.toLowerCase() === '') {
      this.taskCards = this.cards;
    }

  }
}
